export default __webpack_public_path__ + "static/media/dashboard-blue.b2ffc2a0.svg";